import React from 'react';
import { ContentTemplate, HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import WithdrawalReason from '../../modules/withdrawal/WithdrawalReason';

const useStyles = makeStyles()((theme) =>
({
  stepper: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      left: '-15%',
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      left: '-14%',
    },
    [theme.breakpoints.between('xs', 'md')]: {
      left: '-13%',
    },
    [theme.breakpoints.down('sm')]: {
      left: '-6%',
    },
  },
}));

interface SelectSubjectPageProps {
  routeSteps: { label: string }[];
}

const WithdrawalReasonPage = ({ routeSteps }: SelectSubjectPageProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('withdrawal->>WithdrawFromExam.ExamWithdrawal')} />
      <HeaderTemplate>
        <Stepper className={classes.stepper} activeStep={0} steps={routeSteps} />
      </HeaderTemplate>
      <ContentTemplate>
        <WithdrawalReason />
      </ContentTemplate>
    </>
  );
};

export default WithdrawalReasonPage;
